module.exports = __webpack_public_path__ + "static/media/2. Transparencia1, Resina epóxica, 55 x 111 x 4 cm, 2019 copy.b80b69f3.png";